const stopFoulDrawnPlayerActions = [
  {
    actions: [
      { action: "sendEvent", value: "edit", type: "main" },
      { action: "copyEvent", value: "stop-foul-drawn", type: "to" },
      {
        action: "nextState",
        value: "stop-foul-caused-player",
        type: "primary",
      },
    ],
    conditions: [],
  },
];

export const StopFoulDrawnPlayer = {
  name: "stop-foul-drawn-player",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "stopFoul.stoppedPlayer.select",
  showOn: [{ state: "primary", value: "stop-foul-drawn-player", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  showDetails: { events: ["main"] },
  children: [
    {
      name: "stop-foul-drawn-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
      },
      actionGroups: [
        {
          actions: [{ action: "clearData", value: ["flagged"], type: "main" }],
          conditions: [],
        },
        ...stopFoulDrawnPlayerActions,
      ],
    },
    {
      name: "confirm-later-stop-foul-drawn-player",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: "confirmLater",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "saveData", type: "flagged", value: true },
            { action: "clearData", value: ["personId"], type: "main" },
          ],
          conditions: [],
        },
        ...stopFoulDrawnPlayerActions,
      ],
    },
  ],
};
